<script>
import api from '@/helpers/api'
export default {
  name: 'product-category-form-dialog.app',
  props: {
    visible: { type: Boolean, default: false },
    categoryId: { type: String }
  },
  data: () => ({
    category: {},
    isLoading: false
  }),
  methods: {
    reset () {
      this.category = {}
    },
    onCancel () {
      this.$emit('update:visible', false)

      this.$nextTick(() => {
        this.reset()
      })
    },
    async init () {
      if (this.isUpdate) {
        let item = await api.productCategories.fetch({
          id: this.categoryId
        })

        this.category = { ...item }
      } else this.category = {}
    },
    async onSave () {
      let valid = true

      if (valid) {
        try {
          let item
          this.isLoading = true
          if (this.isUpdate) {
            item = await api.productCategories.update({
              ...this.category,
              id: this.categoryId
            })
          } else {
            item = await api.productCategories.create({
              ...this.category
            })
          }
          this.$bvToast.toast(`Category '${this.category.name}' was added!`, {
            title: 'Category Added',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'success',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.isLoading = false

          this.$emit('created', item)
          this.onCancel()
        } catch (err) {
          this.$bvToast.toast(`${err}!`, {
            title: 'Error',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.isLoading = false
        }
      }
    }
  },
  watch: {
    categoryId: { handler: 'init', immediate: true },
    visible: {
      handler (v) {
        if (v) this.init()
      }
    }
  },
  computed: {
    isUpdate () {
      return !!this.categoryId
    },
    title () {
      return this.isUpdate ? 'Edit Category' : 'New Category'
    },
    saveBtnLabel () {
      return this.isUpdate ? 'Save Changes' : 'Create Category'
    }
  }
}
</script>
<template>
  <b-modal
    v-model="visible"
    :title="title"
    centered
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    size="lg"
  >
    <b-form-group label="Name" label-for="category_name" label-cols-sm="3">
      <b-form-input
        id="category_name"
        v-model="category.name"
        type="text"
        required
        autocomplete="category_name"
        placeholder="Short name"
        :style="{ maxWidth: '350px' }"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      label="Description"
      label-for="category_description"
      label-cols-sm="3"
    >
      <b-form-textarea
        id="category_description"
        v-model="category.description"
        type="text"
        required
        autocomplete="category_description"
        placeholder="Short description"
        rows="2"
      ></b-form-textarea>
    </b-form-group>

    <b-form-group
      label="Parent Category"
      label-for="cat_parent_category_id"
      label-cols-sm="3"
    >
      <app-category-selector
        id="cat_parent_category_id"
        v-model="category.parent_category_id"
      />
    </b-form-group>

    <b-form-group
      label-for="is_archived"
      label-cols-sm="3"
      class="d-flex align-items-center"
    >
      <template v-slot:label>
        <div class="d-flex align-items-center pointer">
          Archived
        </div>
      </template>
      <b-form-checkbox
        switch
        size="lg"
        id="is_archived"
        v-model="category.is_archived"
        name="is_archived"
        inline
      ></b-form-checkbox>
    </b-form-group>

    <template v-slot:modal-footer>
      <div class="d-flex justify-content-end" style="width: 100%">
        <div>
          <b-button variant="link" @click="onCancel" class="mr-2"
            >Cancel</b-button
          >
          <b-btn variant="primary" class="btn-label" @click="onSave">
            <i class="bx bxs-save label-icon"></i>
            {{ saveBtnLabel }}
          </b-btn>
        </div>
      </div>
    </template>
  </b-modal>
</template>
